/**
 * PrintHeader — en-tête d'impression des fiches (UPT-2049) : nom du locataire,
 * titre de l'entité et identifiant, date d'impression, utilisateur. Monté une
 * fois (ClientProviders) ; rendu seulement pendant l'impression, et même alors
 * invisible à l'écran (`print-only`, cf. design-system/print.css). Le pied de
 * page reste celui du navigateur (pagination).
 */
import { useIntl } from '@/react-intl';
import { getAuthContextState } from '@/uptk/core/api/auth_context_store';
import { useBranding } from '@/uptk/core/context/branding-context';
import { localeOf } from './displayLocale';
import { buildPrintHeader } from './printModel';
import { usePrintState } from './usePrintMode';

export function PrintHeader() {
  const intl = useIntl();
  const branding = useBranding();
  const print = usePrintState();
  if (!print.printing) return null;

  const auth = getAuthContextState();
  const header = buildPrintHeader({
    tenantName: auth?.tenantName,
    brandName: branding.displayName,
    userLabel: auth?.email,
    context: print.context,
    headingText: print.domTitle,
    documentTitle: typeof document !== 'undefined' ? document.title : '',
    printedAt: print.printedAt ?? Date.now(),
    locale: localeOf(intl),
  });
  const printedOn = intl.formatMessage(
    { id: 'core.print.header.printedOn' },
    { date: header.date, time: header.time },
  );
  const printedBy = header.user === ''
    ? ''
    : intl.formatMessage({ id: 'core.print.header.printedBy' }, { user: header.user });

  return (
    <div className="print-only print-header">
      {header.tenant !== '' && <p className="print-header-tenant">{header.tenant}</p>}
      <p className="print-header-title">
        {header.title}
        {header.identifier !== '' && <span className="print-header-identifier">{header.identifier}</span>}
      </p>
      <p className="print-header-meta">
        {printedOn}
        {printedBy !== '' && <span>{printedBy}</span>}
      </p>
    </div>
  );
}

export default PrintHeader;
